import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { faFilter } from '@fortawesome/pro-solid-svg-icons';

import PageHeader from 'components/page_header';
import StepList from './step_list';
import UploadFile from './upload/upload_file';
import Preview from './preview/preview';
import Run from './run/run';
import Review from './review/review';
import Revert from './revert/revert';

import { saveImport, revertImport, runImport } from './store/actions/import_object';

import './importer_styles.scss';

export class Importer extends React.Component {
  static propTypes = {
    currentStep: PropTypes.string.isRequired,
    importObject: PropTypes.object.isRequired,
    importReverted: PropTypes.bool.isRequired,
    importsListPath: PropTypes.string.isRequired,
    onRevertImport: PropTypes.func.isRequired,
    onRunImport: PropTypes.func.isRequired,
    onSaveImport: PropTypes.func.isRequired
  }

  isStepOneButtonDisabled = () => {
    const { importObject: { files } } = this.props;

    const values = Object.values(files);

    return values.every(file => file.mapperType == "Do Not Import" || file.mapperType == null)
      || values.length === 0;
  }

  renderStep() {
    const { currentStep } = this.props;

    switch (currentStep) {
    case "upload":
      return <UploadFile />;
    case "preview":
      return <Preview />;
    case "run":
      return <Run />;
    case "review":
      return <Review />;
    case "revert":
      return <Revert />;
    default:
      return null;
    }
  }

  renderRevertButton() {
    const { currentStep, onRevertImport, importReverted } = this.props;

    if (currentStep === "review" && !importReverted) {
      return (
        <div
          className="btn btn-danger btn-md"
          onClick={onRevertImport}
        >
          Revert Import
        </div>
      );
    }
  }

  renderBackButton() {
    const { currentStep, importsListPath } = this.props;

    if (currentStep === "review") {
      return (
        <a className="btn btn-save ml-3" href={importsListPath}>
          Back to Imports List
        </a>
      );
    } else {
      return (
        <a className="btn btn-primary ml-3" href={importsListPath}>
          Save as Draft
        </a>
      );
    }
  }

  renderSaveButton() {
    const { currentStep, onRunImport, onSaveImport } = this.props;

    let isDisabled = true;
    let onClick = null;

    if (currentStep == 1) {
      isDisabled = this.isStepOneButtonDisabled();
      if (!isDisabled) {
        onClick = (e) => {
          e.preventDefault();
          onSaveImport();
        };
      }
    } else if (currentStep == 3) {
      isDisabled = false;
      onClick = (e) => {
        e.preventDefault();
        onRunImport();
      };
    }

    if (currentStep !== "review") {
      return (
        <div
          className="btn btn-save btn-md ml-3"
          disabled={isDisabled}
          onClick={onClick}
        >
          Save & Continue
        </div>
      );
    }
  }

  render() {
    const { currentStep, importsListPath } = this.props;

    return (
      <div className="imports-index mb-4">
        <PageHeader
          iconDescription="Import Your Data into Buildout"
          iconName={faFilter}
          iconSize="lg"
          iconText="Import Data"
          iconType="icon"
        >
          <div className="top-bar">
            {this.renderRevertButton()}
            {currentStep !== "review" &&
                <a className="btn btn-cancel" href={importsListPath}>
                  Cancel
                </a>
            }
            {this.renderBackButton()}
            {this.renderSaveButton()}
          </div>
        </PageHeader>
        <StepList />
        {this.renderStep()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentStep: state.ui.currentStep,
  importObject: state.importObject,
  importsListPath: state.paths.importsListPath,
  importReverted: state.ui.importReverted
});

const mapDispatchToProps = {
  onRevertImport: revertImport,
  onRunImport: runImport,
  onSaveImport: saveImport
};

export default connect(mapStateToProps, mapDispatchToProps)(Importer);
